import { jsonFetch } from "utils";

export const getAssets = (companyId) =>
  jsonFetch(`${apiUrl}public/v1/companies/${companyId}/assets`, {
    method: "GET",
  });

export default getAssets;
